import React from "react";
import { Row, Col } from "react-bootstrap";

const NpiView = ({ npiData, onChangeHandler, selectedItems }) => {
  return (
    <React.Fragment>
      {npiData.length ? (
        <div className="dt-each mb-2">
          {/* <div className="mb-1"><strong>SamExclusions</strong></div> */}
          {npiData.map((item, i) => {
            let unverifiedlabel = "";
            let unverifiedBtnClass = "";
            let label = "";
            let btnClass = "";
            if (!item.Verified) {
              unverifiedlabel = "Unverified";
              unverifiedBtnClass = "bg-info";
            }

            return (
              <Row key={i}>
                <Col>
                  <input
                    type="checkbox"
                    id={`psv_item_npi_${item.provider.toString()}_${i}`}
                    checked={
                      selectedItems.some(
                        (selectedItem) =>
                          selectedItem.ProviderID === item.provider &&
                          selectedItem.ProviderNpi &&
                          selectedItem.ProviderNpi.includes(item._id)
                      ) ||
                      (item.submitted_to_verify
                        ? item.submitted_to_verify
                        : false)
                    }
                    onChange={(e) => onChangeHandler(e, "ProviderNpi", item)}
                    disabled={
                      item.submitted_to_verify
                        ? item.submitted_to_verify
                        : false
                    }
                  />
                  <label
                    htmlFor={`psv_item_npi_${item.provider.toString()}_${i}`}
                  >
                    <span className="ml-1">NPI</span>{" "}
                    {unverifiedlabel ? (
                      <span className={`badge ${unverifiedBtnClass}`}>
                        {unverifiedlabel}
                      </span>
                    ) : null}{" "}
                    {label ? (
                      <span className={`badge ${btnClass}`}>{label}</span>
                    ) : null}{" "}
                    {item.submitted_to_verify ? (
                      <span className="badge bg-secondary">In Process</span>
                    ) : null}
                  </label>
                </Col>
              </Row>
            );
          })}
        </div>
      ) : null}
    </React.Fragment>
  );
};

export default NpiView;
